import { render, staticRenderFns } from "./FixedSideMenu.vue?vue&type=template&id=246176ea&scoped=true"
import script from "./FixedSideMenu.vue?vue&type=script&lang=ts"
export * from "./FixedSideMenu.vue?vue&type=script&lang=ts"
import style0 from "./FixedSideMenu.vue?vue&type=style&index=0&id=246176ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246176ea",
  null
  
)

export default component.exports